<template>
    <div class="grafico-container">
        <div class="grafico-header">
            <h3 class="grafico-titulo">Projetos por Setor</h3>
            <GraficoInfoIcon 
                titulo="Projetos por Setor"
                descricao="Mostra a distribuição de projetos por setor, permitindo identificar quais áreas têm mais projetos em execução."
            />
        </div>
        <div v-if="!temDados" class="sem-dados">Nenhum dado disponível</div>
        <Bar v-else :data="chartData" :options="chartOptions" />
    </div>
</template>

<script>
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import GraficoInfoIcon from './GraficoInfoIcon.vue';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default {
    name: 'GraficoProjetosPorSetor',
    components: { Bar, GraficoInfoIcon },
    props: {
        projetos: {
            type: Array,
            default: () => []
        }
    },
    emits: ['clicar-projeto'],
    computed: {
        dadosPorSetor() {
            const setoresMap = {};
            this.projetos.forEach(p => {
                const setor = p.setor?.nome || 'Sem Setor';
                setoresMap[setor] = (setoresMap[setor] || 0) + 1;
            });
            return Object.entries(setoresMap)
                .map(([setor, count]) => ({ setor, count }))
                .sort((a, b) => b.count - a.count)
                .slice(0, 15);
        },
        temDados() {
            return this.dadosPorSetor.length > 0;
        },
        chartData() {
            const dados = this.dadosPorSetor;
            return {
                labels: dados.map(d => d.setor.length > 25 ? d.setor.substring(0, 25) + '...' : d.setor),
                datasets: [{
                    label: 'Projetos',
                    data: dados.map(d => d.count),
                    backgroundColor: 'rgba(54, 117, 211, 0.6)',
                    borderColor: 'rgba(54, 117, 211, 1)',
                    borderWidth: 2
                }]
            };
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: 'y',
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                return `Projetos: ${context.parsed.x}`;
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: 'Quantidade de Projetos'
                        },
                        ticks: {
                            stepSize: 1
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Setores'
                        }
                    }
                }
            };
        }
    }
};
</script>

<style scoped>
.grafico-container {
    background: var(--cor-bg, white);
    border: 1px solid var(--cor-separador, #ddd);
    border-radius: 8px;
    padding: 1.5rem;
    height: 500px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
}

.grafico-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
}

.grafico-titulo {
    margin: 0;
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--cor-fonte, #333);
}

.sem-dados {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
}
</style>

